import { getContext, setContext, hasContext } from 'svelte';
import { derived, writable } from 'svelte/store';

export function upsertAppcuesId(append = '') {
    const appcuesId = getContext('appcuesId');
    if (!hasContext('appcuesId')) {
        return setContext('appcuesId', writable(append));
    }

    if (append !== '' && append !== undefined) {
        return setContext(
            'appcuesId',
            derived(appcuesId, $appcuesId => $appcuesId + `.${append.toLowerCase().replace(' ', '-')}`),
        );
    }

    return appcuesId;
}
